import { updateToolCall } from "../../../../../../../contextManagement/toolCallUpdater.ts";
import {executeAppToolCall} from "../../appToolCallHandler/appToolCallHandler.ts";
import {addToolMessage} from "../../../utils/utils.ts";

export const handleGatherContextMessage = (args: any, llmRequestRefs: any, finishedToolCall: any, setMessages: any, updateElementInProgress: any, currentMessageRef: any, messagesSequenceRef: any, messagesRef: any, environmentObjRef: any, dynamicStateObjRef: any) => {
    // Handle case where finishedToolCall is null - clear state and return early
    if (!finishedToolCall) {
        // Clear any in-progress elements and update messages
        updateElementInProgress('', 'delete');
        return;
    }
    const handleFinish = (results: any) => {
        addToolMessage(finishedToolCall, results, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(finishedToolCall.id, 'delete');
    }

    const toolCallId = finishedToolCall.id;
    const toolCall = llmRequestRefs.current.toolCalls[toolCallId];
    const appPassThroughToolCall = args.toolCall;

    switch (args.type) {
        case 'chunk':
            const currentEvents = toolCall?.chronologicalEvents || [];
            const newChunk = args.chunk;

            // If the last event was also a chunk, append to it
            // Otherwise, start a new chunk event
            const lastEvent = currentEvents[currentEvents.length - 1];
            if (lastEvent && lastEvent.type === 'chunk') {
                // Append to the last chunk
                const updatedEvents = [...currentEvents];
                updatedEvents[updatedEvents.length - 1] = {
                    ...lastEvent,
                    content: lastEvent.content + newChunk
                };

                updateToolCall(llmRequestRefs, toolCallId, {
                    chronologicalEvents: updatedEvents
                });
            } else {
                // Start a new chunk event
                updateToolCall(llmRequestRefs, toolCallId, {
                    chronologicalEvents: [...currentEvents, {
                        type: 'chunk',
                        content: newChunk
                    }]
                });
            }
            break;
        case 'toolCallRequest':
            // Reset chunk sequence tracking when a tool call starts
            updateToolCall(llmRequestRefs, toolCallId, {
                lastEventType: 'toolCallRequest'
            });

            // Only mark as gatherContext if this is not a deepResearch call
            if (finishedToolCall.name !== 'deepResearch') {
                appPassThroughToolCall.args.isGatherContext = true;
            }

            switch (args.toolCall.name) {
                case 'searchCodebase':
                    llmRequestRefs.current.additionalContext.serverResponseResults.filesToPull = args.results;
                    executeAppToolCall(appPassThroughToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, null);
                    break;
                case 'grepCodebase':
                    executeAppToolCall(appPassThroughToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, null);
                    break;
                case 'openFile':
                    executeAppToolCall(appPassThroughToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, null);
                    break;
                case 'viewDirectory':
                    executeAppToolCall(appPassThroughToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, null);
                    break;
                case 'reviewChanges':
                    executeAppToolCall(appPassThroughToolCall, environmentObjRef, llmRequestRefs, dynamicStateObjRef, null);
                    break;
            }
            break;
        case "toolCallInit": {
            const currentEvents = toolCall?.chronologicalEvents || [];
            const messages = toolCall?.messages || [];
            const newMessage = {
                type: 'toolCall',
                name: args.name,
                args: args.args,
                id: args.id,
                status: 'init'
            };

            // Create new message and add to chronological events
            updateToolCall(llmRequestRefs, toolCallId, {
                messages: [...messages, newMessage],
                chronologicalEvents: [...currentEvents, {
                    type: 'toolCall',
                    message: newMessage
                }]
            });
            break;
        }
        case "toolCallFinish": {
            // Find and update the existing message with the matching id
            const messages = toolCall?.messages || [];
            const messageIndex = messages.findIndex((m: any) => m.id === args.id);
            if (messageIndex !== -1) {
                const updatedMessages = [...messages];
                updatedMessages[messageIndex] = {
                    ...updatedMessages[messageIndex],
                    args: args.args,
                    status: 'finish'
                };

                // Also update the corresponding event in chronological events
                const currentEvents = toolCall?.chronologicalEvents || [];
                const updatedEvents = currentEvents.map((event: any) => {
                    if (event.type === 'toolCall' && event.message?.id === args.id) {
                        return {
                            ...event,
                            message: updatedMessages[messageIndex]
                        };
                    }
                    return event;
                });

                updateToolCall(llmRequestRefs, toolCallId, {
                    messages: updatedMessages,
                    chronologicalEvents: updatedEvents
                });
            }
            break;
        }
        case "gatherContextDone":
            // Filter out files that are already in filesAlreadySeen
            const newFileResults: Record<string, string> = {};
            Object.entries(args.seenFilePaths).forEach(([filePath, content]: any) => {
                if (!llmRequestRefs.current.additionalContext.filesAlreadySeen.has(filePath)) {
                    newFileResults[filePath] = content;
                    llmRequestRefs.current.additionalContext.filesAlreadySeen.add(filePath);
                }
            });

            // Update tool call with metadata for UI display (only new files)
            updateToolCall(llmRequestRefs, toolCallId, {
                gatherContextResults: {
                    searchResults: args.seenSearchInternetResults,
                    fileResults: args.seenFilePaths,
                    seenFilePathsArr: args.seenFilePathsArr,
                    seenSearchInternetResultsArr: args.seenSearchInternetResultsArr,
                    reflection: args.reflection
                }
            });

            handleFinish({
                searchResults: args.seenSearchInternetResults,
                fileResults: args.seenFilePaths,
                chronologicalEvents: llmRequestRefs.current.toolCalls[toolCallId].chronologicalEvents,
                seenFilePathsArr: args.seenFilePathsArr,
                seenSearchInternetResultsArr: args.seenSearchInternetResultsArr,
                reflection: args.reflection
            });
            break;
    }

    setMessages((prev: any) => prev.deepCopy());
};